import React, { useState, useEffect } from 'react';
import EnergiaTartaly from './components/EnergiaTartaly';
import { Maximize, Minimize } from 'lucide-react';
import './App.css';

function App() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  return (
    <div className="App">
      <button
        type="button"
        onClick={toggleFullscreen}
        className="fullscreen-btn"
        title={isFullscreen ? 'Kilépés a teljes képernyőből' : 'Teljes képernyő'}
        aria-label={isFullscreen ? 'Kilépés a teljes képernyőből' : 'Teljes képernyő'}
      >
        {isFullscreen ? (
          <Minimize size={22} strokeWidth={2.5} />
        ) : (
          <Maximize size={22} strokeWidth={2.5} />
        )}
      </button>
      <EnergiaTartaly />
    </div>
  );
}

export default App;